<template>
    <!-- eslint-disable max-len -->
    <div>
        <template v-if="!inline">
            <div
                :class="wrapperClass"
                class="cursor-pointer flex items-stretch w-full"
                @click="toggleResortBookingForm"
            >
                <slot />
            </div>

            <portal to="destination">
                <div
                    v-if="showBookingModal"
                    :key="randomId"
                    class="fixed inset-0"
                    style="z-index: 99999"
                >
                    <blocker @click="showBookingModal = false" />
                    <div
                        class="fixed z-50 rounded shadow-lg bg-grey-lightest w-full md:w-3/5"
                        style="
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        "
                    >
                        <div
                            class="fixed right-0 top-0 m-6 border-abs-white text-abs-white border-2 p-2 py-1 cursor-pointer"
                            @click="showBookingModal = false"
                        >
                            X
                        </div>
                        <booking-form
                            :route="route"
                            :language="language"
                            :discounts="discounts"
                            :locations="locations"
                            :groups="groups"
                            :mn="mn"
                        />
                    </div>
                </div>
            </portal>
        </template>
        <template v-else>
            <booking-form
                :inline="inline"
                :route="route"
                :language="language"
                :discounts="discounts"
                :locations="locations"
                :groups="groups"
                :mn="mn"
            />
        </template>
    </div>
</template>

<script>
import Blocker from './utilities/Blocker';

export default {
    name: 'Booking',
    components: {
        Blocker,
    },
    props: {
        mn: {
            type: String,
            default: '',
        },
        remoteEnabled: {
            type: Boolean,
            default: false,
        },
        route: {
            type: String,
            default: null,
        },
        language: {
            type: String,
            default: 'en',
        },
        inline: {
            type: Boolean,
            default: false,
        },
        groups: {
            type: Boolean,
            default: false,
        },
        wrapperClass: {
            type: String,
            default: 'justify-center',
        },
        discounts: {
            type: Object,
            default() {
                return {
                    coupon: null,
                    promo: null,
                    rate: null,
                };
            },
        },
    },
    data() {
        return {
            showBookingModal: false,
            locations: [],
        };
    },
    watch: {
        showBookingModal() {
            this.retrieveResorts();
            // this.findLocation();
        },
    },
    mounted() {
        if (this.inline) {
            this.retrieveResorts();
            // this.findLocation();
        }
        this.startListeners();
    },
    methods: {
        toggleResortBookingForm() {
            if (
                this.currentResortAndBrand &&
                this.currentResortAndBrand?.resort &&
                this.currentResortAndBrand.resort?.booking_settings &&
                this.currentResortAndBrand.resort.booking_settings?.redesign_enabled
            ) {
                window.bus.$emit('toggle-redesign-book-now');
            } else {
                this.showBookingModal = !this.showBookingModal;
            }
        },
        retrieveResorts() {
            const self = this;
            let params = '';

            if (
                this.currentResortAndBrand &&
                this.currentResortAndBrand?.resort &&
                this.currentResortAndBrand.resort?.booking_settings &&
                this.currentResortAndBrand.resort.booking_settings?.only_same_site_resorts
            ) {
                params = `?site_id=${this.currentResortAndBrand.resort.site_id}`;
            }

            window.axios.get(`/api/resorts${params}`).then((response) => {
                self.locations = response.data;
            });
        },
        startListeners() {
            if (this.remoteEnabled) {
                window.bus.$on('open-book-now', () => {
                    this.toggleResortBookingForm();
                });
            }
        },
        // findLocation() {
        //     /* Pass country code, pass region code (GA), city, zip */
        //     // if (navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition(function(position) {});

        //     let testObj = {
        //         accuracy: 71,
        //         altitude: null,
        //         altitudeAccuracy: null,
        //         heading: null,
        //         latitude: 34.0161945,
        //         longitude: -84.4066793,
        //         speed: null
        //     };
        //     // } else {
        //     /* geolocation IS NOT available */
        //     // }
        // }
    },
};
</script>
